export const DevelopmentTemplate = {
    getFormName() {
        return {
            name:"",
            project_name:"",
            hereIsYourWeeklySummaryFrom:"",
            hereIsYourWeeklySummaryTo:"",

            project_address:"",
            expected_date:"",
            project_summary:"",
            schedule:"",
            purchase_close_date:"",
            projected_dp_date:"",
            notes:"",
            address_vp_comment:"",
            expected_date_vp_comment:"",
            project_summary_vp_comments:"",
            schedule_vp_comments:"",

            section_3 : [
                {
                    schedule_milestones:"Fit Study, city planning review, riparian, surve",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Acquisition",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"RFP for Architectural Design",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Engagement with Architect",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Schematic Design Phase",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"RFP's for Civil/Geotech/ Enviro/Arborist/Landscape/ Traffic",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Engagement with Civil/ Geotech/ Enviro/Arborist/ Landscape/ Traffic",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Engagement with Structural Engineer",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Design Development Phase Building Concept Plans Started",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Building Concept Plans internal reviewed/revised & possible staff review",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Complete Civil/ Geotech/ Enviro/Arborist/ Landscape/ Traffic",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Complete Building Concept Plans",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Initial Consultation phase",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Complete application forms, info sheet, assemble app'n info and fees",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Development Application Submitted",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"City planning Review Done",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Planning comment review/revisions",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"APC",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Revisions",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Planning Report Complete",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Council Meeting (Committee of the whole)",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Revisions based on council comments",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"1st or 1st & 2nd reading",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Public Hearing",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Covenant Registration",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Final Reading",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"DP Application",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"DP Issued",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"BP Application",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                {
                    schedule_milestones:"Receive Building Permit",
                    plan_completion_date:"",
                    current_forecast_completion_date:"",
                    actual_completion_date:"",
                    notes:"",
                    vp_comments:""
                },
                
            ],
            section_4 : [
                {
                    activities_worked_on_this_week:"",
                    contractor:"",
                    brief_scope_of_work:"",
                    current_f_c_date:"",
                    vp_comments:""
                }
            ],
            section_5 : [
                {
                    project_budget:"Development Budget",
                    amount:"",
                    vp_comments:""
                },
                {
                    project_budget:"Additional consultants/investigative costs",
                    amount:"",
                    vp_comments:""
                },
                {
                    project_budget:"Total cost to date",
                    amount:"",
                    vp_comments:""
                },
                {
                    project_budget:"Total remaining budget",
                    amount:"",
                    vp_comments:""
                },
            ],
            section_6 : [
                {
                    action_items_discussed:"",
                    vp_comments:"",
                }
            ],




        };
    }
}